import * as React from 'react';
import './styles/styles.scss'

import * as i18n from './i18n';
import { HashRouter } from "react-router-dom";
import { AxiosUtil } from "@app/utils/AxiosUtil";
import { createRoot } from "react-dom/client";
import EnhancedChatGptApp from "@view/EnhancedChatGptApp";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "@app/contexts/ThemeContext";
import { ServiceWorkerUtil } from "@app/utils/ServiceWorkerUtil";
import { HtmlAttributesUtil } from './app/helpers/HtmlAttributesUtil';

const AUTO_RELOAD_ON_UPDATE = true;

const domElement: HTMLElement = document.getElementById('EnhancedChatGpt') as HTMLElement;
const locale = HtmlAttributesUtil.getAttributeAsText(domElement, 'data-locale', 'de');
const apiURI = HtmlAttributesUtil.getAttributeAsText(domElement, 'data-api-uri', 'http://localhost:3000/');
const sentryDsn = HtmlAttributesUtil.getAttributeAsText(domElement, 'data-sentry-dsn', '');

if (sentryDsn.trim() !== '') {
    Sentry.init({
        dsn: sentryDsn,
        integrations: [],
    });
}

i18n.default(locale);
AxiosUtil.configureAxios(apiURI, locale);

/**
 * Register Service Worker for PWA functionality and automatic updates.
 * 
 * This registration only occurs in production builds to enable:
 * - Offline functionality through service worker caching
 * - Automatic detection of new app versions when deployed
 * - Background update checking every 5 minutes
 * 
 * The service worker is not registered in development mode to avoid caching
 * issues during development and to ensure developers always see the latest code.
 */
if (process.env.NODE_ENV === 'production') {
    ServiceWorkerUtil.register(AUTO_RELOAD_ON_UPDATE).then(() => {
        // Start periodic update checks to ensure users get updates even with long sessions
        ServiceWorkerUtil.startPeriodicUpdateCheck();
    });
}

const app = <ThemeProvider>
    <HashRouter>
        <EnhancedChatGptApp />
    </HashRouter>
</ThemeProvider>;

const root = createRoot(domElement); // createRoot(container!) if you use TypeScript
root.render(app);